// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__3JsIn","buttons":"PendingPaymentAlert_buttons__1YYw8"};